var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3333 22.8333V25.3333H7.66663V22.8333C7.66663 22.375 8.04163 22 8.49996 22H23.5C23.9583 22 24.3333 22.375 24.3333 22.8333Z",
    fill: "#667085",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.6667 16.1667H9.33337V22H12.6667V16.1667Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 16.1667H12.6666V22H16V16.1667Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M19.3333 16.1667H16V22H19.3333V16.1667Z",
    fill: "#667085"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.6667 16.1667H19.3334V22H22.6667V16.1667Z",
    fill: "#667085"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1667 25.9583H6.83337C6.49171 25.9583 6.20837 25.675 6.20837 25.3333C6.20837 24.9917 6.49171 24.7083 6.83337 24.7083H25.1667C25.5084 24.7083 25.7917 24.9917 25.7917 25.3333C25.7917 25.675 25.5084 25.9583 25.1667 25.9583Z",
    fill: "#667085"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8083 11.7917L16.3083 8.7917C16.1416 8.72503 15.8583 8.72503 15.6916 8.7917L8.19163 11.7917C7.89996 11.9083 7.66663 12.25 7.66663 12.5667V15.3333C7.66663 15.7917 8.04163 16.1667 8.49996 16.1667H23.5C23.9583 16.1667 24.3333 15.7917 24.3333 15.3333V12.5667C24.3333 12.25 24.1 11.9083 23.8083 11.7917ZM16 14.0833C15.3083 14.0833 14.75 13.525 14.75 12.8333C14.75 12.1417 15.3083 11.5833 16 11.5833C16.6916 11.5833 17.25 12.1417 17.25 12.8333C17.25 13.525 16.6916 14.0833 16 14.0833Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/BankTransfer.194f94a47794a265fa376d3452a35d0f.svg";
export { ForwardRef as ReactComponent };